import dynamic from 'next/dynamic';

import { LinkButton } from '../../../../../components/Toolkit/Button/LinkButton';
import { AdCard } from './components/AdCard/AdCard';
import { Panel } from '../shared/Panel/Panel';

import { useModal } from '../shared/FinanceModal/FinanceModal.hook';

import { type Provider } from '../../../../../components/CarFinancePage/queries/schema/carFinance.schema';
import { type LearnMoreModalProps } from './components/LearnMoreModal/LearnMoreModal';

import { ProviderLogo, Heading, Copy } from './Introduction.styled';

import { CDN_STATIC_ASSETS } from '../../../../../utils';

const DynamicLearnMoreModal = dynamic<LearnMoreModalProps>(
  import('./components/LearnMoreModal/LearnMoreModal').then(
    (mod) => mod.LearnMoreModal,
  ),
  { ssr: false },
);

type IntroductionProps = {
  adId: string;
  make: string;
  model: string;
  price: number;
  provider: Provider;
};

const Introduction = (props: IntroductionProps) => {
  const { adId, make, model, price, provider } = props;

  const {
    isModalOpen: isLearnMoreModalOpen,
    openModal: openLearnMoreModal,
    closeModal: closeLearnMoreModal,
  } = useModal();

  return (
    <Panel mb={['S8', 'M16']} as="div">
      <ProviderLogo
        src={`${CDN_STATIC_ASSETS}/images/thirdparty/${provider}.svg`}
        alt={`${provider} logo`}
        height={76}
      />
      <Heading>Finance Application</Heading>
      <Copy>
        Apply for finance by completing the application form below.&nbsp;
        <LinkButton onClick={openLearnMoreModal} inline>
          Learn more about the process.
        </LinkButton>
      </Copy>
      <AdCard adId={adId} title={`${make} ${model}`} price={price} />
      <DynamicLearnMoreModal
        isOpen={isLearnMoreModalOpen}
        onRequestClose={closeLearnMoreModal}
        provider={provider}
      />
    </Panel>
  );
};

export { Introduction };
